<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>ARNI SCHOOL OF PHARMACY</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Syllabus</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>


<section class="pt-3">
    <div class="container">
        <h3 class="text-center text-primary">Courses</h3>
        <div class="row">
            <div class="col-md-12 col-lg-12 col-sm-12">
                <div class="event-schedule-table table-responsive">
                    <table class="table">
                        <thead>
                        <tr>
                            <th class="time">Syllabus</th>
                            <th class="time">Course_Type</th>
                            <th class="time">Course</th>
                            <th class="time">Sem & Batch</th>

                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="time">
                                <button class="btn bg-primary btn-sm text-white"><i class="fa fa-download"></i> Download
                                </button>
                            </td>
                            <td class="time">Under Graduate</td>
                            <td class="time">B.Pharmacy</td>
                            <td class="time">B.Pharmacy Syllabus</td>
                        </tr>
                        <tr>
                            <td class="time">
                                <button class="btn bg-primary btn-sm text-white"><i class="fa fa-download"></i> Download
                                </button>
                            </td>
                            <td class="time">Diploma</td>
                            <td class="time">D.Pharmacy</td>
                            <td class="time">D.Pharmacy Syllabus</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</section>
